import { render, staticRenderFns } from "./SchulteCircle.vue?vue&type=template&id=a0920130&scoped=true"
import script from "./SchulteCircle.vue?vue&type=script&lang=js"
export * from "./SchulteCircle.vue?vue&type=script&lang=js"
import style0 from "./SchulteCircle.vue?vue&type=style&index=0&id=a0920130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0920130",
  null
  
)

export default component.exports